//For every fecth case to be functional, i need to construct a Fetch case first and make it equal to the same stringname 
//So it can work in the action folder and reducer folder, where I tend to make my fetch cases and create functions connected to the specific Fetch
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS'
export const FETCH_SERVICE_SUCCESS = 'FETCH_SERVICE_SUCCESS'
export const REQUEST_SERVICE = 'REQUEST_SERVICE'

export const SET_AUTH_USER = 'SET_AUTH_USER'
export const RESET_AUTH_STATE = 'RESET_AUTH_STATE'

export const FETCH_USER_SERVICES_SUCCESS = 'FETCH_USER_SERVICES_SUCCESS'
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS'

export const CHANGE_OFFER_STATUS = 'CHANGE_OFFER_STATUS'

export const FETCH_USER_MESSAGES_SUCCESS = 'FETCH_USER_MESSAGES_SUCCESS'
export const MARK_MESSAGE_AS_READ = 'MARK_MESSAGE_AS_READ'

export const COLLABORATION_CREATED_FROM_OFFER = 'COLLABORATION_CREATED_FROM_OFFER'
export const SET_COLLABORATION = 'SET_COLLABORATION'
export const SET_COLLABORATION_JOINED_PEOPLE = 'SET_COLLABORATION_JOINED_PEOPLE' 
export const UPDATE_COLLABORATION_USER = 'UPDATE_COLLABORATION_USER' 
export const SET_COLLABORATION_MESSAGES = 'SET_COLLABORATION_MESSAGES'
export const RESET_COLLABORATION_MESSAGES = 'RESET_COLLABORATION_MESSAGES'
export const REMOVE_COLLABORATION_MESSAGE = 'REMOVE_COLLABORATION_MESSAGE'

export const REQUEST_RESOURCE = 'REQUEST_RESOURCE'
export const FETCH_RESOURCE_SUCCESS = 'FETCH_RESOURCE_SUCCESS' 

